import React from 'react';
import styled from 'styled-components';
import { inputStyles } from './styles/input-styles';

// Context
import { FieldError, useFormContext } from 'react-hook-form';
import { useCubedFormContext } from '../context/form-context';

// Validation
import buildValidators from '../validation/helpers/build-validators';
import { Validator } from '../types';

// Components
import InputContainer from './components/input-container';
import InputErrorMessage from './components/input-error-message';
import IconSearch from '../../../assets/images/icons/search.png';

const StyledInput = styled.input<{ disabled: boolean }>`
    ${inputStyles}
    padding: 0px 10px 0px 40px;
    background-image: url(${IconSearch});
    background-position: 12px center;
    background-size: 18px;
    background-repeat: no-repeat;
`;

export type InputSearchProps = {
    name: string;
    placeholder?: string;
    disabled?: boolean;
    validators?: Validator[];
};

const InputSearch = ({ name, placeholder, disabled, validators = [] }: InputSearchProps) => {
    const { status } = useCubedFormContext();
    const {
        register,
        formState: { errors },
    } = useFormContext();

    return (
        <InputContainer>
            <StyledInput
                id={name}
                type="text"
                placeholder={placeholder}
                disabled={!!disabled || status === 'disabled' || status === 'loading'}
                {...register(name, { ...buildValidators(validators) })}
            />

            {errors[name] && <InputErrorMessage error={errors[name] as FieldError} />}
        </InputContainer>
    );
};

export default InputSearch;
